var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNavercolorinline = function SvgNavercolorinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.553c6.38 0 11.552-5.173 11.552-11.553C23.552 5.62 18.38.447 12 .447S.447 5.62.447 12C.447 18.38 5.62 23.553 12 23.553z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82 6.535h4.3s3.906 5.9 4.022 6.058c.118.16.131 0 .131 0-.18-.913-.375-1.322-.375-2.783V6.535h4.282v10.93h-4.282s-3.826-5.585-3.942-5.74c-.116-.155-.131 0-.131 0 .147.754.277.88.277 2.189v3.551H5.82V6.535z",
    fill: "#19CE60"
  })));
};

export default SvgNavercolorinline;